import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  AppConfigService,
  ISelfServMeta,
  AdviceAidCommonModule,
} from "@aa/common";

import { SelfServMetaCacheService } from "@aa/selfserv/shared";
import { DatePipe } from "@angular/common";
import { MetaStatusPipe } from "@aa/selfserv/shared/directives/meta-status.pipe";

@Component({
  selector: "aa-about-page",
  templateUrl: "./about.component.html",
  host: { class: "anonymous-page" },
  styleUrls: ["./about.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdviceAidCommonModule, DatePipe, MetaStatusPipe],
})
export class AboutComponent {
  public readonly version: string;
  public readonly commit: string | null;
  public readonly serverCommit: string | null;
  public readonly meta: ISelfServMeta | null;

  constructor() {
    const appConfig = inject(AppConfigService);
    const metaCache = inject(SelfServMetaCacheService);

    this.version = "v" + appConfig.version;
    this.commit = appConfig.commit;
    this.serverCommit = appConfig.serverCommit;
    this.meta = metaCache.meta;
  }
}
